import { Box, Stack, Typography } from "@mui/material";
import { Spacing } from "Infrastructure/Themes/Themes";

type Props = {
  title?: string;
  text?: string;
  icon: React.ReactNode;
  actions?: React.ReactNode;
};

export const Empty = ({ title, text, icon, actions }: Props) => {
  return (
    <Stack alignItems={"center"} justifyContent={"center"} height={"200px"} spacing={Spacing.M} px={Spacing.XXXL}>
      <Box p={Spacing.S}>{icon && icon}</Box>
      <Typography variant="body1" fontWeight="600">
        {title}
      </Typography>
      <Typography mt={Spacing.S} mb={Spacing.XL} variant="body2" color="secondary" fontWeight="400" textAlign={"center"}>
        {text}
      </Typography>
      {actions && (
        <Box>
          <Box mt={Spacing.XXL}>{actions}</Box>
        </Box>
      )}
    </Stack>
  );
};
